/* discovered.icon.svg.js */

module.exports = {
    icon: `
    <svg viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path class="foreground-gl" d="M43.9623 85.0429V80.3002L45.5832 78.6192C52.4271 84.5026 61.3122 88.0446 70.9777 88.0446C92.53 88.0446 110 70.5746 110 49.0223C110 27.47 92.53 10 70.9777 10C49.4254 10 31.9554 27.47 31.9554 49.0223C31.9554 58.6878 35.4974 67.5729 41.3808 74.4168L39.6998 76.0377H34.9571L5 106.055L13.9451 115L43.9623 85.0429V85.0429ZM43.9623 49.0223C43.9623 34.0738 56.0292 22.0069 70.9777 22.0069C85.9262 22.0069 97.9931 34.0738 97.9931 49.0223C97.9931 63.9708 85.9262 76.0377 70.9777 76.0377C56.0292 76.0377 43.9623 63.9708 43.9623 49.0223Z" fill="black"/>
    <path class="foreground-gl" d="M84.4348 39L89 43.4118L67.7261 64L54 50.7647L58.5652 46.3529L67.7261 55.1765L84.4348 39Z" fill="black"/>
    </svg>
    
    `
};
